export default __webpack_public_path__ + "static/media/rightel_logo.2b158cef.jpg";